import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { RequireAuth } from "./auth/RequireAuth";
import { ToastProvider } from "./components/ui/Toast";

import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { UsersPage } from "./pages/UsersPage";
import { PostsPage } from "./pages/PostsPage";
import { RoomsPage } from "./pages/RoomsPage";
import { GamesPage } from "./pages/GamesPage";
import { BannersPage } from "./pages/BannersPage";
import { ReportsPage } from "./pages/ReportsPage";
import { NotificationsPage } from "./pages/NotificationsPage";
import { SystemMessagesPage, ActivityMessagesPage } from "./pages/MessagesPages";
import { BotManagementPage } from "./pages/BotManagementPage";
import { BotRoomsPage } from "./pages/BotRoomsPage";
import { CoinLedgerPage } from "./pages/CoinLedgerPage";
import { WithdrawalsPage } from "./pages/WithdrawalsPage";
import { DiamondWithdrawalsPage } from "./pages/DiamondWithdrawalsPage";
import { WithdrawalEligibilityPage } from "./pages/WithdrawalEligibilityPage";
import { CoinProductsPage } from "./pages/CoinProductsPage";
import { CoinAdjustmentsPage } from "./pages/CoinAdjustmentsPage";
import { RoomLevelsPage } from "./pages/RoomLevelsPage";
import { ForbiddenWordsPage } from "./pages/ForbiddenWordsPage";
import { PostReviewPage } from "./pages/PostReviewPage";
import { ExpAdjustmentsPage } from "./pages/ExpAdjustmentsPage";
import { DiamondAdjustmentsPage } from "./pages/DiamondAdjustmentsPage";
import { VipProductsPage } from "./pages/VipProductsPage";
import { ClubsPage } from "./pages/ClubsPage";
import { RankingsPage } from "./pages/RankingsPage";
import { AdminUsersPage } from "./pages/AdminUsersPage";
import { AuditLogPage } from "./pages/AuditLogPage";
import { TranslationsPage } from "./pages/TranslationsPage";
import { SettingsPage, AdsConfigPage, EconomyConfigPage, SystemSenderConfigPage, SecurityConfigPage } from "./pages/SettingsAndAdsPages";
import { LoginMethodsPage } from "./pages/LoginMethodsPage";
import { UniqueIdsPage } from "./pages/UniqueIdsPage";
import { MallCategoriesPage } from "./pages/MallCategoriesPage";
import { MallItemsPage } from "./pages/MallItemsPage";
import { SendMallItemPage } from "./pages/SendMallItemPage";
import { FrameEditorPage } from "./pages/FrameEditorPage";
import { DailySignInPage } from "./pages/DailySignInPage";
import { MedalCategoriesPage } from "./pages/MedalCategoriesPage";
import { MedalsPage } from "./pages/MedalsPage";
import { SendMedalPage } from "./pages/SendMedalPage";
import { AgenciesPage } from "./pages/AgenciesPage";
import { CpEventsPage } from "./pages/CpEventsPage";
import { CustomerCarePage } from "./pages/CustomerCarePage";
import { EmulatorAccessPage } from "./pages/EmulatorAccessPage";
import { HostsPage } from "./pages/HostsPage";
import { AgencyAuditPage } from "./pages/AgencyAuditPage";
import { ChatModerationPage } from "./pages/ChatModerationPage";
import { UserDetailPage } from "./pages/UserDetailPage";
import { GiftsPage } from "./pages/GiftsPage";
import { GiftCatalogPage } from "./pages/GiftCatalogPage";
import { GiftBroadcastLevelsPage } from "./pages/GiftBroadcastLevelsPage";
import { FeedbackPage } from "./pages/FeedbackPage";
import { UserPermissionsPage } from "./pages/UserPermissionsPage";
import { UserBackpackPage } from "./pages/UserBackpackPage";
import { ModerationHistoryPage } from "./pages/ModerationHistoryPage";
import { ForceUpdatePage } from "./pages/ForceUpdatePage";
import { SplashPage } from "./pages/SplashPage";
import { RoomThemesPage } from "./pages/RoomThemesPage";
import { RoomCategoriesPage } from "./pages/RoomCategoriesPage";
import { RoomThemeCategoriesPage } from "./pages/RoomThemeCategoriesPage";
import { RoomReactionsPage } from "./pages/RoomReactionsPage";
import { GiftCategoriesPage } from "./pages/GiftCategoriesPage";
import { PurchasesPage } from "./pages/PurchasesPage";
import { RefundsPage } from "./pages/RefundsPage";
import { RewardsPage } from "./pages/RewardsPage";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />

            <Route
              path="/"
              element={
                <RequireAuth>
                  <DashboardPage />
                </RequireAuth>
              }
            />
            <Route
              path="/users"
              element={
                <RequireAuth>
                  <UsersPage />
                </RequireAuth>
              }
            />
            <Route
              path="/users/:userId"
              element={
                <RequireAuth>
                  <UserDetailPage />
                </RequireAuth>
              }
            />
            <Route
              path="/posts"
              element={
                <RequireAuth>
                  <PostsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/rooms"
              element={
                <RequireAuth>
                  <RoomsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/clubs"
              element={
                <RequireAuth>
                  <ClubsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/chat-moderation"
              element={
                <RequireAuth>
                  <ChatModerationPage />
                </RequireAuth>
              }
            />

            <Route
              path="/coin-ledger"
              element={
                <RequireAuth>
                  <CoinLedgerPage />
                </RequireAuth>
              }
            />
            <Route
              path="/gifts"
              element={
                <RequireAuth>
                  <GiftsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/gift-catalog"
              element={
                <RequireAuth>
                  <GiftCatalogPage />
                </RequireAuth>
              }
            />
            <Route
              path="/gift-broadcast-levels"
              element={
                <RequireAuth>
                  <GiftBroadcastLevelsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/feedback"
              element={
                <RequireAuth>
                  <FeedbackPage />
                </RequireAuth>
              }
            />
            <Route
              path="/room-themes"
              element={
                <RequireAuth>
                  <RoomThemesPage />
                </RequireAuth>
              }
            />
            <Route
              path="/room-theme-categories"
              element={
                <RequireAuth>
                  <RoomThemeCategoriesPage />
                </RequireAuth>
              }
            />
            <Route
              path="/room-categories"
              element={
                <RequireAuth>
                  <RoomCategoriesPage />
                </RequireAuth>
              }
            />
            <Route
              path="/room-reactions"
              element={
                <RequireAuth>
                  <RoomReactionsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/gift-categories"
              element={
                <RequireAuth>
                  <GiftCategoriesPage />
                </RequireAuth>
              }
            />
            <Route
              path="/purchases"
              element={
                <RequireAuth>
                  <PurchasesPage />
                </RequireAuth>
              }
            />
            <Route
              path="/refunds"
              element={
                <RequireAuth>
                  <RefundsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/rewards"
              element={
                <RequireAuth>
                  <RewardsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/coin-products"
              element={
                <RequireAuth>
                  <CoinProductsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/coin-adjustments"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <CoinAdjustmentsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/forbidden-words"
              element={
                <RequireAuth roles={["super_admin", "moderator"]}>
                  <ForbiddenWordsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/post-review"
              element={
                <RequireAuth>
                  <PostReviewPage />
                </RequireAuth>
              }
            />
            <Route
              path="/room-levels"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <RoomLevelsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/exp-adjustments"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <ExpAdjustmentsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/diamond-adjustments"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <DiamondAdjustmentsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/vip-products"
              element={
                <RequireAuth>
                  <VipProductsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/withdrawals"
              element={
                <RequireAuth>
                  <WithdrawalsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/diamond-withdrawals"
              element={
                <RequireAuth>
                  <DiamondWithdrawalsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/withdrawal-eligibility"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <WithdrawalEligibilityPage />
                </RequireAuth>
              }
            />
            <Route
              path="/ads-config"
              element={
                <RequireAuth>
                  <AdsConfigPage />
                </RequireAuth>
              }
            />
            <Route
              path="/economy-settings"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <EconomyConfigPage />
                </RequireAuth>
              }
            />
            <Route
              path="/security-settings"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <SecurityConfigPage />
                </RequireAuth>
              }
            />
            <Route
              path="/system-sender-settings"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <SystemSenderConfigPage />
                </RequireAuth>
              }
            />
            <Route
              path="/user-backpack"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <UserBackpackPage />
                </RequireAuth>
              }
            />
            <Route
              path="/user-permissions"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <UserPermissionsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/splash-screen"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <SplashPage />
                </RequireAuth>
              }
            />
            <Route
              path="/force-update"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <ForceUpdatePage />
                </RequireAuth>
              }
            />
            <Route
              path="/moderation-history"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <ModerationHistoryPage />
                </RequireAuth>
              }
            />

            <Route
              path="/games"
              element={
                <RequireAuth>
                  <GamesPage />
                </RequireAuth>
              }
            />
            <Route
              path="/rankings"
              element={
                <RequireAuth>
                  <RankingsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/banners"
              element={
                <RequireAuth>
                  <BannersPage />
                </RequireAuth>
              }
            />
            <Route
              path="/notifications"
              element={
                <RequireAuth>
                  <NotificationsPage />
                </RequireAuth>
              }
            />

            <Route
              path="/system-messages"
              element={
                <RequireAuth>
                  <SystemMessagesPage />
                </RequireAuth>
              }
            />
            <Route
              path="/activity-messages"
              element={
                <RequireAuth>
                  <ActivityMessagesPage />
                </RequireAuth>
              }
            />

            <Route
              path="/bot-rooms"
              element={
                <RequireAuth>
                  <BotRoomsPage />
                </RequireAuth>
              }
            />

            <Route
              path="/bots"
              element={
                <RequireAuth>
                  <BotManagementPage />
                </RequireAuth>
              }
            />

            <Route
              path="/reports"
              element={
                <RequireAuth>
                  <ReportsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/admin-users"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <AdminUsersPage />
                </RequireAuth>
              }
            />
            <Route
              path="/audit-log"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <AuditLogPage />
                </RequireAuth>
              }
            />
            <Route
              path="/settings"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <SettingsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/login-methods"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <LoginMethodsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/mall-categories"
              element={
                <RequireAuth>
                  <MallCategoriesPage />
                </RequireAuth>
              }
            />
            <Route
              path="/mall-items"
              element={
                <RequireAuth>
                  <MallItemsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/frame-editor"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <FrameEditorPage />
                </RequireAuth>
              }
            />
            <Route
              path="/send-mall-item"
              element={
                <RequireAuth>
                  <SendMallItemPage />
                </RequireAuth>
              }
            />
            <Route
              path="/daily-signin"
              element={
                <RequireAuth>
                  <DailySignInPage />
                </RequireAuth>
              }
            />
            <Route
              path="/medal-categories"
              element={
                <RequireAuth>
                  <MedalCategoriesPage />
                </RequireAuth>
              }
            />
            <Route
              path="/medals"
              element={
                <RequireAuth>
                  <MedalsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/customer-care"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <CustomerCarePage />
                </RequireAuth>
              }
            />
            <Route
              path="/emulator-access"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <EmulatorAccessPage />
                </RequireAuth>
              }
            />
            <Route
              path="/cp-events"
              element={
                <RequireAuth>
                  <CpEventsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/agencies"
              element={
                <RequireAuth>
                  <AgenciesPage />
                </RequireAuth>
              }
            />
            <Route
              path="/hosts"
              element={
                <RequireAuth>
                  <HostsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/agency-audit"
              element={
                <RequireAuth>
                  <AgencyAuditPage />
                </RequireAuth>
              }
            />
            <Route
              path="/send-medal"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <SendMedalPage />
                </RequireAuth>
              }
            />
            <Route
              path="/unique-ids"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <UniqueIdsPage />
                </RequireAuth>
              }
            />
            <Route
              path="/translations"
              element={
                <RequireAuth roles={["super_admin"]}>
                  <TranslationsPage />
                </RequireAuth>
              }
            />
          </Routes>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
